import styled from '@emotion/styled'
import { Grid } from '@mui/material'
import { Container } from '@mui/system'
import React from 'react'
import LockerMenu from '../../Components/LockerMenu'
import { Btn, P } from '../../Styles/style'

import bkImg from '../../../assets/SB-bg.png'
import puppy from '../../../assets/puppy.png'
import copy from '../../../assets/copy.png'

const HeaderWrapper = styled.div`
    background-image: url(${bkImg});
    
  min-height: calc( 100vh - 90px);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    z-index:-1;
`
const HeaderInner = styled.div`
    z-index:-1;
  min-height: calc( 100vh - 90px);
  display: flex;
  justify-content: center;
  align-items: center;
`

const HeaderHeading = styled.h1`

text-shadow: -3px 7px 0px #ffffff;
  font-size: 130px;
  color: #BA51FF;
  text-align: center;
  margin: 0 auto 1rem;
  text-transform: uppercase;
  font-family: "RifficFree-Bold";
  @media screen and (max-width: 760px) {font-size: 89px;}
  @media screen and (max-width: 500px) {font-size: 50px;}
`
const CaBg = styled.div`
padding: 15px 20px;
border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width:100%;
  max-width: 700px;
  border: 1px solid #000;
  background: #FFFFFF;
  position: relative;
  :before{
    content: "";
    position: absolute;
    top: 100%;
    right: 33px;
    width: 0;
    border-top: 20px solid #aaaaaa4e;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;

  }
`
const CaHeading = styled.div`
color: #BA51FF;
  font-family: "Poppins-Bold";
`
const CaTba = styled.div`
color: #000;
  font-family: "Poppins-Bold";
`
const Div = styled.div`
display: flex;
justify-content: center;
`
const DogDIv = styled.div`
display: flex;
justify-content: flex-end;
padding: 0 150px ;
@media screen and (max-width:1200px){
  padding: 0 90px ;
}
@media screen and (max-width:850px){
  padding: 0 0px ;
}
`
const DogImg = styled.img`
width: 100%;
height: auto;
max-width: 150px;
`
const DIv = styled.div`

`
const DIv2 = styled.div`
box-shadow:0px 0px 7px 1px rgb(0 0 0 / 36%);
z-index:-9999;
`
const Header = () => {
  return (
    <div >
      <DIv>
        <LockerMenu />
      </DIv>
      <DIv2>
    <HeaderWrapper >
        <HeaderInner >
          <Container >
            <Grid container>
              <Grid xs={12} style={{textAlign: '-webkit-center' ,textAlign:'-moz-center'}}>
                  <HeaderHeading>SanshuInu</HeaderHeading>
                <P fs="15px" align="center" maxWidth="540px" m="1.5rem auto">Sanshu Inu is following her big brother (Shiba Inus) footsteps in hopes of becoming as great as him one day! Since she loves Shiba Inu so much, she has decided to create a token that rewards all Sanshu Inu holders with Shiba rewards.</P>
                <Div>
                <CaBg>
                  <CaHeading>Contract</CaHeading>
                  <CaTba>TBA <img src={copy}/></CaTba>
                </CaBg>
                </Div>
                <DogDIv>

                <DogImg src={puppy} />
                </DogDIv>
              </Grid>
            </Grid>
          </Container>
        </HeaderInner>
    </HeaderWrapper>
    </DIv2>
    </div>
  )
}

export default Header